import {createContext, useContext} from "react";

export type GeolocationContextType = {
    showGeolocationPermissionDeniedModal: () => void;
};

export const GeolocationContext = createContext<GeolocationContextType | null>(null);

export function useGeolocationContext() {
    const context = useContext(GeolocationContext);
    if (!context) {
        throw new Error("useGeolocationContext must be used within a GeolocationProvider");
    }
    return context;
}
